import * as z from 'zod';

/** Payload for the cancel-order modal. Opened from a row/detail action. */
export const cancelOrderPayloadSchema = z.object({
  orderId: z.union([z.string(), z.number()]),
  displayId: z.union([z.string(), z.number()]).optional(),
  /** Order stage — gates the "cancel courier transaction" checkbox (stage 8). */
  stage: z.number(),
});
export type CancelOrderPayload = z.infer<typeof cancelOrderPayloadSchema>;

/** Payload for the re-offer modal: pick a specific courier for this order. */
export const reOfferPayloadSchema = z.object({
  orderId: z.union([z.string(), z.number()]),
});
export type ReOfferPayload = z.infer<typeof reOfferPayloadSchema>;
